//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { insertOrUpdateStudy } from '@/https/prepareEnroll'
import { success } from '@/utils/notify.js'
import {
  CompareExpression,
  MaxLength,
} from '@/utils/validatorClass'
import { cloneDeep } from '@/utils/lodash'
import {
  DatePicker,
  Input,
} from '@/constant/componentConfig'
import CForm from '@/components/CForm'

export default {
  components: { CForm },

  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return { studyInfo: {} }
  },

  computed: {
    renderData () {
      return [
        new DatePicker({
          value: 'qssj',
          label: '起始日期',
          required: true,
          rules: [new CompareExpression('起始日期', 'qssj <= jzsj')],
        }),
        new DatePicker({
          value: 'jzsj',
          label: '终止日期',
          required: true,
          rules: [new CompareExpression('终止日期', 'jzsj >= qssj')],
        }),
        new Input({
          value: 'jdxx',
          required: true,
          label: '就读学校',
          rules: [new MaxLength('就读学校', 120)],
        }),
        new Input({
          value: 'drzw',
          label: '担任职务',
          rules: [new MaxLength('担任职务', 60)],
        }),
        new Input({
          value: 'zmr',
          label: '证明人',
          rules: [new MaxLength('证明人', 20)],
        }),

      ]
    },
  },

  watch: {
    model: {
      handler (val, oldVal) {
        if (val) {
          this.studyInfo = cloneDeep(val)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {

    async save () {
      if (!await this.$refs.form.validate()) {
        return
      }

      const { code } = await insertOrUpdateStudy({ ...this.studyInfo })

      if (+code === 0) {
        success('保存成功')
        setTimeout((e) => {
          this.$emit('do-handler-success')
          this.$emit('on-back')
        }, 400)
      }
    },
  },
}
